import { render, staticRenderFns } from "./PrestigeFootMenu.vue?vue&type=template&id=341eacd0&scoped=true&"
import script from "./PrestigeFootMenu.vue?vue&type=script&lang=js&"
export * from "./PrestigeFootMenu.vue?vue&type=script&lang=js&"
import style0 from "./PrestigeFootMenu.vue?vue&type=style&index=0&id=341eacd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341eacd0",
  null
  
)

export default component.exports